// Section 2 of the whitelabel T&Cs, as supplied by Paul on 2026-10-26.
// 2.1 quotes each site's own sourcing fee, excluding VAT.
export interface TermsClause {
  number: string
  paragraphs: string[]
}

export function buildSourcingFeeClauses(fee: { percentage: string; minimum: string }): TermsClause[] {
  return [
    {
      number: '2.1.',
      paragraphs: [
        `If you decide to proceed with the purchase of the reserved property, a property sourcing fee of ${fee.percentage}% of the purchase price plus VAT will apply. A minimum sourcing fee of ${fee.minimum} plus VAT is applicable in all cases.`,
      ],
    },
    {
      number: '2.2.',
      paragraphs: ['Upon confirmation of your decision to proceed, you will be required to pay 50% of the sourcing fee upfront.'],
    },
    {
      number: '2.3.',
      paragraphs: [
        'The 50% upfront sourcing fee is refundable only if the sale falls through through no fault of the Buyer, such as vendor withdrawal, failed legal checks or circumstances that prevent the agreed offer conditions from being fulfilled, subject to applicable law.',
      ],
    },
    {
      number: '2.4.',
      paragraphs: [
        'If the sale falls through due to any fault, action or decision of the Buyer, the 50% upfront sourcing fee will be non-refundable, provided that the property remains mortgageable, the agreed offer conditions remain achievable and the material terms of the purchase have not changed, unless otherwise agreed in writing or required by law.',
      ],
    },
    {
      number: '2.5.',
      paragraphs: ['The remaining 50% balance of the sourcing fee is payable upon completion of the property purchase.'],
    },
    {
      number: '2.6.',
      paragraphs: [
        'Where a survey identifies advisory items, maintenance requirements or repairs that do not render the property unmortgageable, and the Buyer chooses to withdraw from the purchase as a result, the sourcing/reservation fee will remain non-refundable, unless otherwise agreed in writing or required by law. The Buyer acknowledges that properties may require ongoing maintenance and that advisory findings do not, in themselves, automatically entitle the Buyer to a refund.',
      ],
    },
    {
      number: '2.7.',
      paragraphs: [
        'If the Buyer chooses to withdraw from the purchase for any other reason, the sourcing/reservation fee will remain non-refundable, provided that the property remains mortgageable, the agreed offer conditions remain achievable, the material terms of the purchase have not changed, and no other refund right has been expressly agreed in writing or arises under applicable law.',
      ],
    },
    {
      number: '2.8.',
      paragraphs: [
        'The sourcing/reservation fee is paid in connection with the offer and the agreed purchase terms. Where any special conditions are stated in the offer, the non-refundable fee provisions apply only where those conditions can be fulfilled and the relevant offer terms, including the agreed purchase price and any conditions affecting the offer, have not materially changed.',
        'If the offer conditions cannot be fulfilled or the agreed terms materially change, any entitlement to a refund will be assessed in accordance with the written offer, any separate reservation agreement and applicable law.',
      ],
    },
    {
      number: '2.9.',
      paragraphs: [
        'Where the Buyer withdraws from the purchase and the offer conditions remain capable of being fulfilled, the agreed purchase price and other material offer terms remain unchanged, and the property remains mortgageable, the sourcing/reservation fee will not be refunded, unless a refund is required by law or expressly agreed in writing.',
      ],
    },
  ]
}
